import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import moment from 'moment';
import Service from '../../services';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';

class NotificationHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notificationHistory: [],
            historyLoading: false,
            historyDetailsDialog: false,
            selectedHistoryItem: null,
            responseDetailsDialog: false,
            responseContent: '',
            totalBatches: 0
        };
        this.service = new Service();
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible && this.props.selectedNotification) {
            this.fetchNotificationHistory(this.props.selectedNotification._id);
        }
    }

    fetchNotificationHistory = (notificationManagerId) => {
        this.setState({ historyLoading: true, notificationHistory: [] });

        const url = `${baseUrlAdmin}/notification-history/history/${notificationManagerId}`;
        this.service.get(url, true)
            .then(res => {
                if (res && res.res && res.res.status) {
                    const data = res.res.data;
                    this.setState({
                        notificationHistory: data.history || [],
                        totalBatches: data.totalBatches || 0,
                        historyLoading: false
                    });
                } else {
                    this.setState({ historyLoading: false });
                    this.showToast('error', 'Error', 'Failed to fetch notification history');
                }
            })
            .catch(e => {
                this.setState({ historyLoading: false });
                this.showToast('error', 'Error', e.message || 'Failed to fetch notification history');
            });
    }

    viewHistoryDetails = (historyItem) => {
        this.setState({
            historyDetailsDialog: true,
            selectedHistoryItem: historyItem
        });
    }

    viewResponseDetails = (response) => {
        this.setState({
            responseDetailsDialog: true,
            responseContent: response
        });
    }

    showToast = (severity, summary, detail) => {
        if (this.toast) {
            this.toast.show({ severity, summary, detail, life: 3000 });
        }
    }

    onHide = () => {
        this.setState({
            notificationHistory: [],
            historyLoading: false,
            totalBatches: 0
        });
        this.props.onHide();
    }

    onHideDetails = () => {
        this.setState({
            historyDetailsDialog: false,
            selectedHistoryItem: null
        });
    }

    onHideResponse = () => {
        this.setState({
            responseDetailsDialog: false,
            responseContent: ''
        });
    }

    renderChannelBadge = (channel) => {
        return (
            <span className={`channel-badge ${channel?.toLowerCase()}`}>
                {channel?.toUpperCase()}
            </span>
        );
    }

    renderStatusBadge = (status) => {
        return (
            <span className={`status-badge ${status?.toLowerCase()}`}>
                {status?.toUpperCase()}
            </span>
        );
    }

    renderSuccessRate = (rowData) => {
        const successCount = rowData.processingResults?.successCount || 0;
        const totalRecipients = rowData.processingResults?.totalRecipients || 0;
        const successRate = totalRecipients > 0 ? ((successCount / totalRecipients) * 100).toFixed(1) : 0;

        return (
            <div className="flex align-items-center">
                <span className="text-sm mr-2">
                    {successCount}/{totalRecipients}
                </span>
                <span className={`success-rate ${successRate === '100.0' ? 'success' : successRate === '0.0' ? 'error' : 'warning'}`}>
                    ({successRate}%)
                </span>
            </div>
        );
    }

    renderMessageContent = (historyItem) => {
        const { channel, data } = historyItem;

        if (channel === 'email') {
            return (
                <div>
                    <div className="mb-2">
                        <strong>Subject:</strong> {data?.subject}
                    </div>
                    <div className="mb-2">
                        <strong>Body:</strong>
                        <div className="p-2 surface-200 border-round mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                            {data?.body}
                        </div>
                    </div>
                    {data?.fileName && (
                        <div>
                            <strong>Attachment:</strong> {data.fileName}
                        </div>
                    )}
                </div>
            );
        }

        if (channel === 'sms') {
            return (
                <div>
                    <strong>Message:</strong>
                    <div className="p-2 surface-200 border-round mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                        {data?.message}
                    </div>
                </div>
            );
        }

        if (channel === 'whatsapp') {
            return (
                <div>
                    <div className="mb-2">
                        <strong>Template:</strong> {data?.templateName || 'N/A'}
                    </div>
                    <div className="mb-2">
                        <strong>Message:</strong>
                        <div className="p-2 surface-200 border-round mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                            {data?.message || 'No message content'}
                        </div>
                    </div>
                    {data?.params && (
                        <div className="mb-2">
                            <strong>Parameters:</strong>
                            <div className="p-2 surface-200 border-round mt-1">
                                {JSON.stringify(data.params, null, 2)}
                            </div>
                        </div>
                    )}
                </div>
            );
        }

        if (channel === 'alert') {
            return (
                <div>
                    <div className="mb-2">
                        <strong>Title:</strong> {data?.title}
                    </div>
                    <div className="mb-2">
                        <strong>Description:</strong>
                        <div className="p-2 surface-200 border-round mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                            {data?.description}
                        </div>
                    </div>
                    {data?.fileName && (
                        <div>
                            <strong>Attachment:</strong> {data.fileName}
                        </div>
                    )}
                </div>
            );
        }

        return <div>No content available</div>;
    }

    renderIndividualResult = (rowData) => {
        if (typeof rowData.result === 'string') {
            return <span className="text-capitalize">{rowData.result}</span>;
        } else if (typeof rowData.result === 'object') {
            return (
                <div>
                    <div><strong>Status:</strong> <span className="text-capitalize">{rowData.result.status}</span></div>
                    {rowData.result.mobile && <div><strong>Mobile:</strong> {rowData.result.mobile}</div>}
                    {rowData.result.response && (
                        <div className="mt-1">
                            <Button
                                label="View Response"
                                className="p-button-text p-button-sm"
                                onClick={() => this.viewResponseDetails(rowData.result.response)}
                            />
                        </div>
                    )}
                </div>
            );
        }
        return <span>-</span>;
    }

    render() {
        const { visible, selectedNotification } = this.props;
        const {
            notificationHistory,
            historyLoading,
            historyDetailsDialog,
            selectedHistoryItem,
            responseDetailsDialog,
            responseContent,
            totalBatches
        } = this.state;

        return (
            <>
                {/* Main History Dialog */}
                <Dialog
                    visible={visible}
                    style={{ width: '85vw', maxHeight: '90vh' }}
                    header={() => (
                        <div className='mt-4'>
                            <h3 className="text-center formhead">
                                Notification History - {selectedNotification?.name}
                            </h3>
                            {totalBatches > 0 && (
                                <p className="text-center text-sm text-600 mt-1">
                                    Total Batches: {totalBatches}
                                </p>
                            )}
                        </div>
                    )}
                    modal
                    onHide={this.onHide}
                    maximizable
                >
                    <div className="p-3">
                        {historyLoading ? (
                            <LoadingComponent />
                        ) : (
                            <DataTable
                                value={notificationHistory}
                                paginator
                                rows={10}
                                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                responsiveLayout="scroll"
                                emptyMessage="No notification history found"
                                sortMode="single"
                                sortField="sentAt"
                                sortOrder={-1}
                            >
                                <Column
                                    field="batchId"
                                    header="Batch ID"
                                    style={{ width: "180px" }}
                                    body={(rowData) => (
                                        <span className="text-sm font-mono" title={rowData.batchId}>
                                            {rowData.batchId?.substring(0, 8)}...
                                        </span>
                                    )}
                                />
                                <Column
                                    field="channel"
                                    header="Channel"
                                    style={{ width: "100px" }}
                                    body={(rowData) => this.renderChannelBadge(rowData.channel)}
                                />
                                <Column
                                    field="sentAt"
                                    header="Sent At"
                                    style={{ width: "160px" }}
                                    sortable
                                    body={(rowData) => (
                                        <span>
                                            {moment(rowData.sentAt).format('MMM DD, YYYY')}
                                            <br />
                                            <small className="text-600">
                                                {moment(rowData.sentAt).format('h:mm A')}
                                            </small>
                                        </span>
                                    )}
                                />
                                <Column
                                    field="recipientCount"
                                    header="Recipients"
                                    style={{ width: "100px" }}
                                    sortable
                                    body={(rowData) => (
                                        <span className="font-semibold text-blue-600">
                                            {rowData.recipientCount || 0}
                                        </span>
                                    )}
                                />
                                <Column
                                    field="status"
                                    header="Status"
                                    style={{ width: "100px" }}
                                    body={(rowData) => this.renderStatusBadge(rowData.status)}
                                />
                                <Column
                                    field="triggeredBy"
                                    header="Triggered By"
                                    style={{ width: "120px" }}
                                    body={(rowData) => (
                                        <span className="text-sm">
                                            {rowData.triggeredBy.slice(3) || 'System'}
                                        </span>
                                    )}
                                />
                                <Column
                                    header="Success Rate"
                                    style={{ width: "130px" }}
                                    body={this.renderSuccessRate}
                                />
                                <Column
                                    header="Actions"
                                    style={{ width: "100px" }}
                                    body={(rowData) => (
                                        <Button
                                            icon="pi pi-eye"
                                            className="p-button-text p-button-sm"
                                            onClick={() => this.viewHistoryDetails(rowData)}
                                            tooltip="View Details"
                                        />
                                    )}
                                />
                            </DataTable>
                        )}
                    </div>
                </Dialog>

                {/* Detailed History Dialog */}
                <Dialog
                    visible={historyDetailsDialog}
                    style={{ width: '90vw', maxHeight: '85vh' }}
                    header={() => (
                        <div className='mt-4'>
                            <h3 className="text-center formhead">
                                Notification Details
                            </h3>
                            <p className="text-center text-sm text-600 mt-1">
                                Batch ID: {selectedHistoryItem?.batchId?.substring(0, 16)}...
                            </p>
                        </div>
                    )}
                    modal
                    onHide={this.onHideDetails}
                    maximizable
                >
                    <div className="p-3">
                        {selectedHistoryItem && (
                            <div>
                                {/* Summary Section */}
                                <div className="grid mb-4">
                                    <div className="col-12">
                                        <h4 className="mb-3">Summary</h4>
                                        <div className="grid">
                                            <div className="col-3">
                                                <div className="p-2 surface-100 border-round">
                                                    <strong>Channel:</strong><br />
                                                    {this.renderChannelBadge(selectedHistoryItem.channel)}
                                                </div>
                                            </div>
                                            <div className="col-3">
                                                <div className="p-2 surface-100 border-round">
                                                    <strong>Status:</strong><br />
                                                    {this.renderStatusBadge(selectedHistoryItem.status)}
                                                </div>
                                            </div>
                                            <div className="col-3">
                                                <div className="p-2 surface-100 border-round">
                                                    <strong>Recipients:</strong><br />
                                                    <span className="font-semibold text-blue-600">
                                                        {selectedHistoryItem.recipientCount}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-3">
                                                <div className="p-2 surface-100 border-round">
                                                    <strong>Triggered By:</strong><br />
                                                    <span>{selectedHistoryItem?.triggeredBy}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="grid mt-2">
                                            <div className="col-4">
                                                <div className="p-2 surface-100 border-round">
                                                    <strong>Sent At:</strong><br />
                                                    <span>{moment(selectedHistoryItem.sentAt).format('MMM Do YYYY, h:mm:ss a')}</span>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="p-2 surface-100 border-round">
                                                    <strong>Success:</strong><br />
                                                    <span className="text-green-600 font-semibold">
                                                        {selectedHistoryItem.processingResults?.successCount || 0}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="p-2 surface-100 border-round">
                                                    <strong>Failures:</strong><br />
                                                    <span className="text-red-600 font-semibold">
                                                        {selectedHistoryItem.processingResults?.failureCount || 0}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Message Content Section */}
                                <div className="mb-4">
                                    <h4 className="mb-3">Message Content</h4>
                                    <div className="p-3 surface-100 border-round">
                                        {this.renderMessageContent(selectedHistoryItem)}
                                    </div>
                                </div>

                                {/* Individual Results Section */}
                                <div>
                                    <h4 className="mb-3">Individual Results</h4>
                                    <DataTable
                                        value={selectedHistoryItem.processingResults?.individualResults || []}
                                        paginator
                                        rows={10}
                                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                        responsiveLayout="scroll"
                                        emptyMessage="No individual results found"
                                    >
                                        <Column
                                            field="username"
                                            header="Username"
                                            body={(rowData) => (
                                                <span className="font-semibold">{(rowData?.username).slice(3)}</span>
                                            )}
                                        />
                                        <Column
                                            field="userId"
                                            header="User ID"
                                            body={(rowData) => (
                                                <span className="text-sm font-mono">{rowData.userId}</span>
                                            )}
                                        />
                                        <Column
                                            field="status"
                                            header="Status"
                                            body={(rowData) => this.renderStatusBadge(rowData.status)}
                                        />
                                        <Column
                                            field="result"
                                            header="Result"
                                            body={this.renderIndividualResult}
                                        />
                                    </DataTable>
                                </div>
                            </div>
                        )}
                    </div>
                </Dialog>

                {/* Response Details Dialog */}
                <Dialog
                    visible={responseDetailsDialog}
                    style={{ width: '70vw', maxHeight: '80vh' }}
                    header="Response Details"
                    modal
                    onHide={this.onHideResponse}
                >
                    <div className="p-3">
                        <div className="p-3 surface-100 border-round">
                            <pre style={{
                                whiteSpace: 'pre-wrap',
                                fontSize: '12px',
                                maxHeight: '400px',
                                overflow: 'auto'
                            }}>
                                {responseContent}
                            </pre>
                        </div>
                    </div>
                </Dialog>

                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </>
        );
    }
}

export default NotificationHistory;
